import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import openInBrowser from '@bridebook/web/lib/utils/open-in-browser';
import useHotelPlannerUrl from '@bridebook/web/lib/wedding-website/hotels/use-hotel-planner-url';
import { isHotelsSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useWeddingWebsiteData } from '../../data/data-context';
import { MotifOrnament, MotifSectionHookProps } from './motif-section-hooks';

export const MotifHotels = (hookProps: MotifSectionHookProps) => {
  const { t } = useTranslation('weddingWebsite');
  const { website, wedding, mainSupplier, isGuestView } = useWeddingWebsiteData();
  const section = website.sections.find(isHotelsSection);
  const dispatch = useDispatch();

  const hotelPlannerUrl = useHotelPlannerUrl({ supplier: mainSupplier, weddingDate: wedding.date });
  const handleHotelPlannerUrlClick = useCallback(() => {
    if (isGuestView) {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'weddingWebsites',
          clickedSection: 'placesToStay',
          cta: 'Explore local hotels',
          trackingTarget: 'BigQuery',
        }),
      );
    }
    openInBrowser(hotelPlannerUrl);
  }, [dispatch, hotelPlannerUrl, isGuestView]);

  return (
    <section {...hookProps} className="bb-ww__section bb-ww__section--stay">
      <MotifOrnament />
      <h2 className="bb-ww__section-title">{t('previewMode.tile.hotels.title')}</h2>
      <p className="bb-ww__body">{section?.data.message}</p>
      <button
        className="bb-ww__button bb-ww__button--hotels"
        type="button"
        onClick={handleHotelPlannerUrlClick}>
        {t('previewMode.tile.hotels.cta')}
      </button>
    </section>
  );
};
